import {
  initialFilterState as peopleInitialFilterState,
  usePeopleFiltersContext,
} from '@sales-app/context/peopleFilters/peopleFilters'
import {
  defaultFilterState as bookingInitialFilterState,
  usePotentialBookingFiltersContext,
} from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import { useNavigate } from 'react-router-dom'

import { Card } from '@/views/Dashboard/Card'

export const DashboardStats = (props: any) => {
  const { setFilters: setPeopleFilters } = usePeopleFiltersContext()
  const { setFilters: setPotentialBookingFilters } = usePotentialBookingFiltersContext()

  const navigate = useNavigate()

  const handlePotentialDuplicates = () => {
    setPeopleFilters({ ...peopleInitialFilterState, includeDuplicates: true })
    navigate('/people')
  }

  const handleRoutePotentialBookingsById = (ids: number[] | null) => {
    const bookingIds = ids && ids.length > 0 ? ids : null
    setPotentialBookingFilters({ ...bookingInitialFilterState, potentialBookingIds: bookingIds })
    navigate('/potential-booking')
  }

  return (
    <div className="grid grid-cols-3 grid-rows-1 place-items-stretch gap-3 md:gap-6">
      <Card
        label="Potential Bookings Worked"
        loading={false}
        onClick={() => handleRoutePotentialBookingsById(props.data.potentialBookingsWorked)}
        subLabel="This Week"
        value={props.data.potentialBookingsWorked?.length}
      />
      <Card label="Reservations Created" loading={false} subLabel="This Week" value={props.data.reservationsCreated} />
      <Card
        label="Potential Duplicates"
        loading={false}
        onClick={() => handlePotentialDuplicates()}
        value={props.data.potentialDuplicates}
      />
      <Card
        label="Potential Bookings Not Contacted"
        loading={false}
        onClick={() => handleRoutePotentialBookingsById(props.data.potentialBookingsNotContacted1Day)}
        subLabel="Past 1 Day"
        value={props.data.potentialBookingsNotContacted1Day?.length}
      />
      <Card
        label="Potential Bookings with Move In"
        loading={false}
        onClick={() => handleRoutePotentialBookingsById(props.data.potentialBookingsMoveIn2Weeks)}
        subLabel="Next 2 Weeks"
        value={props.data.potentialBookingsMoveIn2Weeks?.length}
      />
    </div>
  )
}
